'use es6';

import { Component } from 'react';
import { RichTextTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { sanitizeHTML } from 'FormsUI/utils/SanitizeHTML';
import { jsx as _jsx } from "react/jsx-runtime";
export default class RichText extends Component {
  shouldComponentUpdate({
    content
  }) {
    const {
      type,
      content: oldContent
    } = this.props;
    if (type === RichTextTypes.TEXT) {
      return true;
    }
    try {
      const divEl = document.createElement('div');
      divEl.innerHTML = oldContent;
      const oldAlt = divEl.firstChild.alt;
      divEl.innerHTML = content;
      const newAlt = divEl.firstChild.alt;
      return oldAlt === newAlt;
    } catch (error) {
      return true;
    }
  }
  render() {
    const {
      content
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "draggable-form-element__rich-text",
      dangerouslySetInnerHTML: {
        __html: sanitizeHTML(content)
      }
    });
  }
}
RichText.defaultProps = {
  content: ''
};